import { render, staticRenderFns } from "./observe-v2.vue?vue&type=template&id=795c8a48&scoped=true"
import script from "./observe-v2.vue?vue&type=script&lang=js"
export * from "./observe-v2.vue?vue&type=script&lang=js"
import style0 from "./observe-v2.vue?vue&type=style&index=0&id=795c8a48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c8a48",
  null
  
)

export default component.exports